import type { ListBuilderList } from '../../../types';
import { createMerchandiserTemplateColumns } from '../columns';

/**
 * All Templates list (PD-15559) — backed by the merchandiser_template entity
 * (/api/merchandiser-templates/list). A template is a whole merchandiser
 * setup written down once; this list is how one is found, edited, or retired.
 */
export const allMerchandiserTemplatesList: ListBuilderList = {
	id: 'default-merchandiser-templates',
	name: 'All Templates',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createMerchandiserTemplateColumns(),
	defaultSortId: 'merchandiser-template-name',
	sortOrder: 0,
};
